/** @format */

import { RoleState } from "./interface";

export const initialState: RoleState = {
  role: "",
};
